import { DateTime } from 'luxon';
import * as yup from 'yup';

import { getNowDate } from '@clearverify/utils';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  phoneNumberValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { PersonalInformationFormFields } from '../types';

enum StatusValue {
  NOT_FILLED_IN = 'notFilledIn',
}

export const getPersonalInformationFormValidationSchema = (isEmployee: boolean) => {
  return yup.object({
    [PersonalInformationFormFields.firstName]: yup
      .string()
      .nullable()
      .required('First Name field is required'),
    [PersonalInformationFormFields.lastName]: yup
      .string()
      .nullable()
      .required('Last Name field is required'),
    [PersonalInformationFormFields.phoneNumber]: phoneNumberValidationSchema
      .nullable()
      .required('Phone Number field is required'),
    [PersonalInformationFormFields.birthDate]: yup
      .date()
      .nullable()
      .test('inRange', 'Birth date must be earlier than or equal to today', value => {
        const birthDate = value ? DateTime.fromJSDate(value) : StatusValue.NOT_FILLED_IN;

        const today = getNowDate();
        const rangeCheckResult =
          birthDate === StatusValue.NOT_FILLED_IN
            ? true
            : birthDate.isValid && birthDate.toISODate() < today;

        return rangeCheckResult;
      }),
    ...(isEmployee
      ? {
          [PersonalInformationFormFields.homeAddress]: yup.object({
            [AddressFieldsFormFields.street]: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
            [AddressFieldsFormFields.city]: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
            [AddressFieldsFormFields.county]: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
            [AddressFieldsFormFields.state]: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
            [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
              ERROR_MESSAGE_REQUIRED_ZIP_CODE,
            ),
          }),
        }
      : {}),
  });
};
